import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { OmrState } from './state';

const defaultState: OmrState = {
  uploadImageState: {
    img_list: [],
    score_name: '',
  },
  autoShowStatementDialog: true,
};

export const omrModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
